import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "ya-wrapper-conter"
};
import YAHeader from './components/YAHeader';
import YAOrder from './components/YAOrder';
import YACommonLinks from './components/YACommonLinks';
import RecommendedAsins from '@/components/recommendedAsins/RecommendedAsins.vue';
import { ref, watch, onMounted, onUnmounted, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { Bridge } from '@/utils/bridge';
import { useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import { getCandidates, getCustomerReview } from '@/models/api/yourOrderApi.js';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents, loadingEvents } from '@/configs/awsRumConfig';
import { useRecordLoadingEvent } from '@/models/hooks';
import { SET_AGENT_DATA } from '@/store/mutations.types';
import customerReviewConstants from '@/views/yourOrder/customerReview/constants.js';
var CANDIDATES_PAGE_SIZE = 1;
var CUSTOMER_REVIEW_PAGE_SIZE = 1;
export default {
  __name: 'YourAccount',
  setup(__props) {
    useLess('views/yourAccount/YourAccount.less');
    useRecordLoadingEvent(duration => _objectSpread(_objectSpread({}, loadingEvents.yourAccountPage.yourAccountPage), {}, {
      duration
    }));
    var router = useRouter();
    var isLogin = ref(false);
    var store = useStore();
    var customerReviewCount = reactive({
      commmentedCount: 0,
      toBeCommentedCount: 0
    });
    var CUSTOMER_REVIEW_STATUS_ENUM = customerReviewConstants.CUSTOMER_REVIEW_STATUS_ENUM;
    var distanceFromTop = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.top;
    });
    var tabbarHeight = computed(() => {
      var _store$state$common$t;
      return (_store$state$common$t = store.state.common.tabbarHeight) !== null && _store$state$common$t !== void 0 ? _store$state$common$t : 0;
    });
    var getNumberOfComments = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Promise.all([getCandidates({
                pageSize: CANDIDATES_PAGE_SIZE
              }), getCustomerReview({
                pageSize: CUSTOMER_REVIEW_PAGE_SIZE,
                status: CUSTOMER_REVIEW_STATUS_ENUM.REJECTED
              }), getCustomerReview({
                pageSize: CUSTOMER_REVIEW_PAGE_SIZE,
                status: CUSTOMER_REVIEW_STATUS_ENUM.VISIBLE
              })]);
            case 3:
              result = _context.sent;
              customerReviewCount.toBeCommentedCount = result[0].data.total + result[1].data.total;
              customerReviewCount.commmentedCount = result[2].data.total;
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function getNumberOfComments() {
        return _ref.apply(this, arguments);
      };
    }();
    var checkIsLogIn = () => {
      // Is the user logged in
      Bridge.callFn('isAuthenticated', null, resultData => {
        isLogin.value = resultData === null || resultData === void 0 ? void 0 : resultData.result;
        if (isLogin.value) {
          getNumberOfComments();
        }
      });
    };
    var onAddToCartConfirm = () => {
      awsRumHandler.recordClickEvent(clickEvents.yourAccountPage.addToCartButton);
    };
    watch(() => router.currentRoute.value.name, newRouter => {
      if (newRouter === 'yourAccount') {
        checkIsLogIn();
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      store.commit(`navigator/${SET_AGENT_DATA}`, {
        top: 0
      });
    });
    onUnmounted(() => {
      store.commit(`navigator/${SET_AGENT_DATA}`);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "ya-wrapper",
        style: _normalizeStyle({
          paddingTop: distanceFromTop.value + 'px'
        })
      }, [_createVNode(_unref(YAHeader), {
        isLogin: isLogin.value,
        "onUpdate:isLogin": _cache[0] || (_cache[0] = $event => isLogin.value = $event),
        customerReviewCount: customerReviewCount
      }, null, 8, ["isLogin", "customerReviewCount"]), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(YAOrder), {
        isLogin: isLogin.value,
        "onUpdate:isLogin": _cache[1] || (_cache[1] = $event => isLogin.value = $event),
        toBeCommentedCount: customerReviewCount.toBeCommentedCount
      }, null, 8, ["isLogin", "toBeCommentedCount"]), _createVNode(_unref(YACommonLinks), {
        isLogin: isLogin.value,
        "onUpdate:isLogin": _cache[2] || (_cache[2] = $event => isLogin.value = $event)
      }, null, 8, ["isLogin"])])], 4), _createVNode(RecommendedAsins, {
        class: "ya-recommended-asins-area",
        onOnAddCartConfirm: onAddToCartConfirm,
        title: _ctx.$t('common.BEST_SELLING_ITEM_RECOMMENDATION'),
        style: _normalizeStyle({
          paddingBottom: tabbarHeight.value + 'px'
        })
      }, null, 8, ["title", "style"])], 64);
    };
  }
};